export function getExperienceName (num) {
  switch (Number(num)) {
    case 0:
      return 'Festive';
    case 1:
      return 'Tranquil';
    case 2:
      return 'Family';
    default:
      return null;
  }
}
